module.exports = __webpack_public_path__ + "static/satya-nadella-bba34f035ce9a2d2e2cf97fd150e5ec9.jpg";